 <div class='partner-infos__details'>
     <div class='partner-infos__details--title'>
         {{ '$partner$ souhaite collaborer avec vous' | transloco: {
                        partner: invitation.account.organization_name
                    } }}
     </div>
     <div class="partner-infos__details--infos blue">
         <a (click)="showPartnerInfos()"
            class="link blue">
             {{ ('Coordonnees du partenaire' | transloco) }}
         </a>
         <span class="separator"> | </span>
       <a (click)="openFAQ(2667)"
            class="link blue">
             {{ ('Qu\'est-ce qu\'un partenaire ?' | transloco) }}
         </a>
     </div>
 </div>
